<template>
  <div>
    <b-columns is-multiline>
      <b-column
        class="is-half-desktop"
        v-for="pictogram in pictograms"
        :key="pictogram.code"
      >
        <b-columns
          class="is-vcentered"
          is-multiline
          is-mobile
        >
          <b-column class="is-narrow">
            <figure :class="isSmall ? 'image is-48x48' : 'image is-96x96'">
              <img
                :src="pictogram.pictogram"
                :alt="pictogram.code"
              >
            </figure>
          </b-column>
          <b-column>
            <p>{{ `${pictogram.code} ${pictogram.description}` }}</p>
          </b-column>
        </b-columns>
      </b-column>
    </b-columns>
  </div>
</template>

<script>
export default {
  props: {
    pictograms: {
      type: Array,
      required: true
    },
    isSmall: {
      type: Boolean,
      required: false
    }
  }
}
</script>
